import React from "react";

class DCA extends React.Component {
  render() {
    return (
      <section id="dcadvantage" className="theme-bg-dca screenshots">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <div className="section-title">
                <h2 className="text-white">DCAdvantage</h2>
                <p className="text-white">(hired)</p>
                <img
                  src="https://cdn.johnbernazzani.com/white-line.svg"
                  alt="title-line"
                  className="img-fluid title-line"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <img
                src="https://cdn.johnbernazzani.com/dca_laptop.png"
                className="img-fluid"
                alt="1"
              />
            </div>
          </div>
          <div className="row m-0">
            <div className="col-12 text-center app-description">
              <h1>
                <i className="fa fa-desktop" />
              </h1>
              <p>
                A web app that allows engineers to plot and fit decline curves
                on imported production data. Featured include spreadsheet
                functionality, real-time curve adjustments, highly interactive
                plot, and widget calculators.
              </p>
              <a
                href="https://rarepetro.com/dcadvantage"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="btn btn-primary">Learn More</button>
              </a>
            </div>
          </div>
          <div className="row crafted-with">
            <div className="col-12 text-center">
              <p>Crafted with</p>
            </div>
          </div>
          <div className="row tech-stack d-flex flex-row justify-content-center">
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/html5.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/bootstrap.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/js.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/php.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/postgresql.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/aws.png" alt="1" />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default DCA;



// WEBPACK FOOTER //
// ./src/components/dca.js